<div class="col-12">
  <nav class="menu" tabindex="0">
    <div class="smartphone-menu-trigger"></div>
    <header class="col-12">
      <div class="side-avtar">
        <img src="./assets/images/logo.png" class="col-7 img-fluid" alt="..." />
        <ng-container *ngIf="initialized$ | async">
          <ng-container *ngIf="companyLogoUrl$ | async as companyLogoUrl; else defaultLogo">
            <img [src]="companyLogoUrl" class="col-5 img-fluid padding-left-10" alt="..." />
          </ng-container>
          <ng-template #defaultLogo>
            <img src="./assets/images/relativity-logo.png" class="col-5 img-fluid padding-left-10" alt="..." />
          </ng-template>
        </ng-container>
      </div>
    </header>
    <ng-container *ngIf="initialized$ | async; else navShimmer">
      <ul>
        <a [routerLink]="DASHBOARD" *ngIf="(enabledModules$ | async)?.includes('DASHBOARD')">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg" /><span>Dashboard</span></li>
        </a>
        <a [routerLink]="ACTIVITY_DASHBOARD" *ngIf="(enabledModules$ | async)?.includes('ACTIVITY_TRACKER')">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg" /><span>Activity Board</span></li>
        </a>
        <a [routerLink]="QUERY_DASHBOARD" *ngIf="(enabledModules$ | async)?.includes('QUERIES')">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg" /><span>Employee Queries</span></li>
        </a>
        <a [routerLink]="KNOWLEDGE_HUB" *ngIf="(enabledModules$ | async)?.includes('KNOWLEDGE_BANK')">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg" /><span>Knowledge Hub</span></li>
        </a>
        <a [routerLink]="PROFILE">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg" /><span>My Profile</span></li>
        </a>
        <a [routerLink]="SETTINGS">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg" /><span>Settings</span></li>
        </a>
        <a [routerLink]="HELP" *ngIf="showHelpPage$ | async">
          <li tabindex="0" class="icon"><img src="/assets/images/svg/right-arrow.svg" /><span>Help</span></li>
        </a>
      </ul>
    </ng-container>

    <ng-template #navShimmer>
      <div class="shimmer-list">
        <div class="shimmer-item" *ngFor="let i of [1,2,3,4,5,6,7]">
          <div class="shimmer-icon"></div>
          <div class="shimmer-label"></div>
        </div>
      </div>
    </ng-template>
  </nav>
</div>
